import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { confirm } from 'devextreme/ui/dialog';
import { resolve } from 'path';

@Component({
  selector: 'app-ecran-detail',
  templateUrl: './ecran-detail.component.html',
  styleUrls: ['./ecran-detail.component.css']
})
export class EcranDetailComponent implements OnInit {
  @Input() detailName: string;
  @Input() detail: any;
  @Input() DBDetail: any;
  @Input() customTemplate: TemplateRef<any>;

  @Input() displayId: boolean = false;

  @Input() hasButton1: boolean = false;
  @Input() textButton1: string;
  @Input() iconButton1: string;

  @Input() hasButton2: boolean = false;
  @Input() textButton2: string;
  @Input() iconButton2: string;

  @Input() hasButton3: boolean = false;
  @Input() disableButton3: boolean = false;
  @Input() textButton3: string;
  @Input() iconButton3: string;

  @Input() isActionButtonsVisible: boolean = true;

  @Input() isRetourCarte: boolean = false;
  @Output() onButton1: EventEmitter<any> = new EventEmitter();
  @Output() onButton2: EventEmitter<any> = new EventEmitter();
  @Output() onButton3: EventEmitter<any> = new EventEmitter();
  @Output() onReturnCarte: EventEmitter<any> = new EventEmitter();
  @Output() onReturnListe: EventEmitter<any> = new EventEmitter();
  @Output() onCancel: EventEmitter<any> = new EventEmitter();
  @Output() onSave: EventEmitter<any> = new EventEmitter();

  set isDetailEdited(bool: boolean) {}
  get isDetailEdited(): boolean {
    if (this.DBDetail == null) { return true; }
    return JSON.stringify(this.detail) !== JSON.stringify(this.DBDetail);
  }

  constructor(private translate: TranslateService) { }

  ngOnInit() {
  }

  clickButton1() {
    this.onButton1.emit(true);
  }

  clickButton2() {
    this.onButton2.emit(true);
  }

  clickButton3() {
    this.onButton3.emit(true);
  }

  async returnToMap() {
    let test = await this.showNotificationContinue();
    if (test) {
      this.onReturnCarte.emit(true);
    }
  }

  async returnToList() {
    let test = await this.showNotificationContinue();
    if (test) {
      this.onReturnListe.emit(true);
    }
  }

  cancelClicked(e = null): void {
    this.onCancel.emit(e);
  }

  saveClicked(e = null): void {
    this.onSave.emit(e);
  }

  async showNotificationContinue(): Promise<boolean> {
    if (this.isDetailEdited) {
      const message = this.translate.instant('Dialog.ContinueConfirmQuestion');
      const title = this.translate.instant('Dialog.ContinueConfirm');
      const result = confirm(message, title);

      return await result.then(dialogResult => {
        return dialogResult;
      });
    } else {
      return true;
    }
  }
}
